import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {Price_Badge} from '../../../../types/Price';
import {Badge, SalesCell} from './Shared';

export const PriceBadge: FC<{
  badge: Price_Badge;
  CountdownComponent?: React.ComponentType<{
    endDate: Date;
    backgroundColor?: string;
  }>;
}> = ({badge, CountdownComponent}) => {
  return (
    <StyledSalesCell>
      {CountdownComponent && badge.endsAt && (
        <CountdownComponent
          endDate={badge.endsAt}
          backgroundColor={badge.backgroundColor.hex}
        />
      )}
      <Badge
        data-testid="badge-sale"
        data-has-countdown={Boolean(CountdownComponent && badge.endsAt)}
        $foregroundColor={badge.foregroundColor.hex}
        $backgroundColor={badge.backgroundColor.hex}
        data-untranslated-label="sale"
      >
        {badge.text}
      </Badge>
    </StyledSalesCell>
  );
};

const StyledSalesCell = styled(SalesCell)`
  margin-right: 0;
`;
